import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import ProgressBar from '../../../ProgressBar';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import s from './UploadThumb.scss';

export interface Props {
  className?: string;
  file: File;
  progress?: number;
  error?: Error;
}

class UploadThumb extends React.Component<React.PropsWithChildren<Props & WithTranslation>> {
  preview: React.RefObject<any> = React.createRef();

  componentDidMount() {
    // set the preview of the file currently being uploaded
    const reader = new FileReader();
    reader.onload = e => {
      if (this.preview.current && e.target) {
        this.preview.current.src = (e.target as any).result; // TS3 dom lib is a bit dumb for now
      }
    };
    reader.readAsDataURL(this.props.file);
  }

  render() {
    const { className, progress = 0, error } = this.props;
    return (
      <div className={classnames(s['root'], className)}>
        <img
          loading="lazy"
          className={s['preview']}
          alt={this.props.t('mediapopup.uploadThumb.alt')}
          ref={this.preview}
        />
        {error && <div className={s['error']}>{error?.message || error.toString()}</div>}
        {!error && progress >= 1 && (
          <LoadingIndicator className={s['please-wait']} spinnerClassName={s['spinner']} />
        )}
        {!error && (
          <ProgressBar
            className={classnames(s['progress'], progress >= 1 && s['progress-done'])}
            barClassName={s['bar']}
            background="none"
            percentage={progress * 100}
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(UploadThumb) as React.ComponentClass<Props>;
